import {_googleMarker} from './freeEvents';

export function getVenueMarkers(): _googleMarker[] {
  return VENUES.map((venueData) => {
    return {
      position: {
        lat: venueData.Y,
        lng: venueData.X
      },
      key: venueData.GlobalID,
      defaultAnimation: 4,
      showInfo: false,
      venueData: venueData,
      type: 'venue'
    };
  });
}

export interface VenueData {
  X: number,
  Y: number,
  OBJECTID: number,
  GlobalID: string,
  VENUE_NAME: string,
  VENUE_CODE: string,
  VENUE_TYPE: string,
  SPORT_1: string,
  SPORT_2: string,
  SPORT_3: string,
  SPORT_4: string,
  SPORT_5: string,
  DESCRIPTION: string,
}

export const VENUES: VenueData[] = [
  {
    "X": 153.13399408965,
    "Y": -27.50812986077916,
    "OBJECTID": 1,
    "GlobalID": "d16643d5-9be6-4425-aba1-a7ac4bad104f",
    "VENUE_NAME": "Belmont Shooting Centre",
    "VENUE_CODE": "BEL",
    "VENUE_TYPE": "Competition",
    "SPORT_1": "Shooting",
    "SPORT_2": "",
    "SPORT_3": "",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "Belmont Shooting Centre"
  },
  {
    "X": 153.14654307985867,
    "Y": -27.51503162734992,
    "OBJECTID": 2,
    "GlobalID": "52c5ade6-2be7-490f-bd58-0da0f9af9992",
    "VENUE_NAME": "Queensland State Velodrome",
    "VENUE_CODE": "QSV",
    "VENUE_TYPE": "Competition",
    "SPORT_1": "Cycling Track",
    "SPORT_2": "",
    "SPORT_3": "",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "Queensland State Velodrome"
  },
  {
    "X": 153.31437694225656,
    "Y": -27.911608274333062,
    "OBJECTID": 3,
    "GlobalID": "4421074f-43c7-41ec-9e2c-43263ac645fe",
    "VENUE_NAME": "Oxenford Studios",
    "VENUE_CODE": "OXN",
    "VENUE_TYPE": "Competition",
    "SPORT_1": "Boxing",
    "SPORT_2": "Table Tennis",
    "SPORT_3": "Squash",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "Oxenford Studios"
  },
  {
    "X": 153.31951439748494,
    "Y": -27.865818684188557,
    "OBJECTID": 4,
    "GlobalID": "6c782975-818f-4578-9d07-d0dbacb33ded",
    "VENUE_NAME": "Coomera Indoor Sport Centre",
    "VENUE_CODE": "CSC",
    "VENUE_TYPE": "Competition",
    "SPORT_1": "Gymnastics",
    "SPORT_2": "Gymnastics Artistic",
    "SPORT_3": "Gymnastics Rhythmic",
    "SPORT_4": "Netball",
    "SPORT_5": "",
    "DESCRIPTION": "Coomera Indoor Sport Centre"
  },
  {
    "X": 153.33545876344772,
    "Y": -27.985919941064896,
    "OBJECTID": 5,
    "GlobalID": "6d6b0080-a9f2-4a6e-a614-fe4dae42a40b",
    "VENUE_NAME": "Nerang State Forest",
    "VENUE_CODE": "NER",
    "VENUE_TYPE": "Competition",
    "SPORT_1": "Mountain Bike",
    "SPORT_2": "",
    "SPORT_3": "",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "Nerang State Forest"
  },
  {
    "X": 153.4124647678672,
    "Y": -27.95913188938473,
    "OBJECTID": 6,
    "GlobalID": "1e2f9e05-13fa-4cb9-9f99-f48f73ebc7ff",
    "VENUE_NAME": "Southport Broadwater Parklands South",
    "VENUE_CODE": "SBP",
    "VENUE_TYPE": "Competition",
    "SPORT_1": "Athletics",
    "SPORT_2": "",
    "SPORT_3": "",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "Southport Broadwater Parklands South - Marathon and Mass Participation Event"
  },
  {
    "X": 153.41583980755996,
    "Y": -27.9637728916529,
    "OBJECTID": 7,
    "GlobalID": "af527189-0913-4da4-90bc-eeac7acca64a",
    "VENUE_NAME": "Gold Coast Aquatic Centre",
    "VENUE_CODE": "GAC",
    "VENUE_TYPE": "Competition",
    "SPORT_1": "Aquatics",
    "SPORT_2": "Swimming",
    "SPORT_3": "Diving",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "Gold Coast Aquatic Centre"
  },
  {
    "X": 153.39360515231348,
    "Y": -27.954534176917267,
    "OBJECTID": 8,
    "GlobalID": "7b6228d7-d793-4044-8827-c27bc50f2433",
    "VENUE_NAME": "Gold Coast Hockey Centre",
    "VENUE_CODE": "GHC",
    "VENUE_TYPE": "Competition",
    "SPORT_1": "Hockey",
    "SPORT_2": "",
    "SPORT_3": "",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "Gold Coast Hockey Centre"
  },
  {
    "X": 153.39657532759583,
    "Y": -27.908967010829336,
    "OBJECTID": 9,
    "GlobalID": "f92d7589-4a12-4047-8f80-853dfaf025b2",
    "VENUE_NAME": "Runaway Bay Sports Super Centre",
    "VENUE_CODE": "RBS",
    "VENUE_TYPE": "Training",
    "SPORT_1": "Squash",
    "SPORT_2": "Weightlifting",
    "SPORT_3": "Hockey",
    "SPORT_4": "Athletics",
    "SPORT_5": "",
    "DESCRIPTION": "Runaway Bay Sports Centre"
  },
  {
    "X": 153.3671200320619,
    "Y": -28.006332826104334,
    "OBJECTID": 10,
    "GlobalID": "543afddc-99e5-4a63-b68d-831b0b8d5d04",
    "VENUE_NAME": "Carrara Stadium",
    "VENUE_CODE": "CAR",
    "VENUE_TYPE": "Competition",
    "SPORT_1": "Athletics",
    "SPORT_2": "Opening Ceremony",
    "SPORT_3": "Closing Ceremony",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "Carrara Stadium"
  },
  {
    "X": 153.3642457276816,
    "Y": -28.004433949166607,
    "OBJECTID": 11,
    "GlobalID": "7a39b848-f549-4111-b5bc-262c718ddab9",
    "VENUE_NAME": "Carrara Sport and Leisure Centre",
    "VENUE_CODE": "CSL",
    "VENUE_TYPE": "Competition",
    "SPORT_1": "Badminton",
    "SPORT_2": "Wrestling",
    "SPORT_3": "",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "Carrara Sport and Leisure Centre"
  },
  {
    "X": 153.43172980478678,
    "Y": -28.02111596206532,
    "OBJECTID": 12,
    "GlobalID": "09c03cd6-6d10-4935-8fd6-e12373e1e5ab",
    "VENUE_NAME": "Broadbeach Bowls Club",
    "VENUE_CODE": "BLB",
    "VENUE_TYPE": "Competition",
    "SPORT_1": "Lawn Bowls",
    "SPORT_2": "",
    "SPORT_3": "",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "Broadbeach Bowls Club"
  },
  {
    "X": 153.378808323939,
    "Y": -28.06681737009801,
    "OBJECTID": 13,
    "GlobalID": "c833430c-ed71-4040-8281-7850977d7385",
    "VENUE_NAME": "Robina Stadium",
    "VENUE_CODE": "ROB",
    "VENUE_TYPE": "Competition",
    "SPORT_1": "Rugby Sevens",
    "SPORT_2": "",
    "SPORT_3": "",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "Robina Stadium"
  },
  {
    "X": 153.42876550358807,
    "Y": -28.02851798891015,
    "OBJECTID": 14,
    "GlobalID": "3c3f79ea-405f-4cfc-b150-1861c044ed55",
    "VENUE_NAME": "Gold Coast Convention and Exhibition Centre",
    "VENUE_CODE": "GCE",
    "VENUE_TYPE": "Competition",
    "SPORT_1": "Basketball",
    "SPORT_2": "Netball",
    "SPORT_3": "",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "Gold Coast Convention and Exhibition Centre"
  },
  {
    "X": 153.36536924791255,
    "Y": -28.005556602795668,
    "OBJECTID": 15,
    "GlobalID": "878041a8-287b-4c2b-b08f-ef660f2d5b01",
    "VENUE_NAME": "Carrara Indoor Sports Stadium",
    "VENUE_CODE": "CIS",
    "VENUE_TYPE": "Competition",
    "SPORT_1": "Weightlifting",
    "SPORT_2": "Powerlifting",
    "SPORT_3": "",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "Carrara Indoor Sports Stadium"
  },
  {
    "X": 153.38462828767925,
    "Y": -27.982134734009406,
    "OBJECTID": 16,
    "GlobalID": "1acfad64-ea35-4330-8811-0d1e5345c4d7",
    "VENUE_NAME": "Ashmore PCYC",
    "VENUE_CODE": "AYC",
    "VENUE_TYPE": "Training",
    "SPORT_1": "Boxing",
    "SPORT_2": "",
    "SPORT_3": "",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "Ashmore PCYC"
  },
  {
    "X": 153.3798840933227,
    "Y": -28.071281794567987,
    "OBJECTID": 17,
    "GlobalID": "6e54ffc7-9aae-49a9-85bd-a83119dba6cc",
    "VENUE_NAME": "Bond University",
    "VENUE_CODE": "BND",
    "VENUE_TYPE": "Training",
    "SPORT_1": "Rugby Sevens",
    "SPORT_2": "",
    "SPORT_3": "",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "HP Centre Robina - HP Centre provides a first class gym and pool for teams"
  },
  {
    "X": 153.35518099164295,
    "Y": -27.98569265261771,
    "OBJECTID": 18,
    "GlobalID": "30e9b811-41fb-4da1-ba85-d50a7659b070",
    "VENUE_NAME": "Gold Coast Table Tennis Centre",
    "VENUE_CODE": "GTT",
    "VENUE_TYPE": "Training",
    "SPORT_1": "Table Tennis",
    "SPORT_2": "",
    "SPORT_3": "",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "Gold Coast Table Tennis Centre"
  },
  {
    "X": 153.37816630429364,
    "Y": -27.96214237616536,
    "OBJECTID": 19,
    "GlobalID": "c210f8ca-6a06-429d-92a4-eb82fb2a41a5",
    "VENUE_NAME": "Griffith University Sports Centre",
    "VENUE_CODE": "GUS",
    "VENUE_TYPE": "Training",
    "SPORT_1": "",
    "SPORT_2": "",
    "SPORT_3": "",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "Griffith University Sports Centre"
  },
  {
    "X": 153.3955973757635,
    "Y": -27.956312767302773,
    "OBJECTID": 20,
    "GlobalID": "2d86bca0-8a50-4e82-83f5-82b2ac695bd5",
    "VENUE_NAME": "Musgrave Hills Bowls Club",
    "VENUE_CODE": "MHB",
    "VENUE_TYPE": "Training",
    "SPORT_1": "",
    "SPORT_2": "",
    "SPORT_3": "",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "Musgrave Hills Bowls Club"
  },
  {
    "X": 153.3886041583632,
    "Y": -27.959113215162432,
    "OBJECTID": 21,
    "GlobalID": "fe9d66be-c7fb-462f-b90a-3791d40f173f",
    "VENUE_NAME": "Parkwood Sharks Oval",
    "VENUE_CODE": "PSO",
    "VENUE_TYPE": "Training",
    "SPORT_1": "",
    "SPORT_2": "",
    "SPORT_3": "",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "Parkwood Sharks Oval"
  },
  {
    "X": 153.388546304164,
    "Y": -27.961835017022246,
    "OBJECTID": 22,
    "GlobalID": "410a7cdd-cbdc-47d5-8282-97ecc3148745",
    "VENUE_NAME": "Commonwealth Games Village",
    "VENUE_CODE": "CGV",
    "VENUE_TYPE": "Training",
    "SPORT_1": "",
    "SPORT_2": "",
    "SPORT_3": "",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "Commonwealth Games Village"
  },
  {
    "X": 153.48652896849595,
    "Y": -28.1280695323644,
    "OBJECTID": 23,
    "GlobalID": "53c8ebd2-f05c-4924-802a-998d14d4cfca",
    "VENUE_NAME": "Currumbin Beachfront",
    "VENUE_CODE": "CUR",
    "VENUE_TYPE": "Competition",
    "SPORT_1": "Cycling Road Events",
    "SPORT_2": "Athletics",
    "SPORT_3": "",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "Currumbin Beachfront"
  },
  {
    "X": 153.4124647678672,
    "Y": -27.95913188938473,
    "OBJECTID": 24,
    "GlobalID": "94602847-c04b-42cc-a6fc-d567a20cc2a6",
    "VENUE_NAME": "Southport Broadwater Parklands North",
    "VENUE_CODE": "SBP",
    "VENUE_TYPE": "Competition",
    "SPORT_1": "Triathlon",
    "SPORT_2": "",
    "SPORT_3": "",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "Southport Broadwater Parklands North"
  },
  {
    "X": 145.77807355260165,
    "Y": -16.927607536980418,
    "OBJECTID": 25,
    "GlobalID": "eb27931e-5e61-4325-9091-e2a7d7153bd7",
    "VENUE_NAME": "Cairns Convention Centre",
    "VENUE_CODE": "CCV",
    "VENUE_TYPE": "Competition",
    "SPORT_1": "Basketball",
    "SPORT_2": "",
    "SPORT_3": "",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "Cairns Convention Centre"
  },
  {
    "X": 146.82767587621433,
    "Y": -19.25071781856578,
    "OBJECTID": 26,
    "GlobalID": "ab3d9672-336c-4ce6-ac36-77c3c7337da2",
    "VENUE_NAME": "Townsville Entertainment and Convention Centre",
    "VENUE_CODE": "TEN",
    "VENUE_TYPE": "Competition",
    "SPORT_1": "Basketball",
    "SPORT_2": "",
    "SPORT_3": "",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "Townsville Entertainment and Convention Centre"
  },
  {
    "X": 145.7531276102495,
    "Y": -16.924841621301812,
    "OBJECTID": 27,
    "GlobalID": "c0fef122-348d-4c67-8ea0-fe19a1ac6bb1",
    "VENUE_NAME": "Cairns Basketball Stadium",
    "VENUE_CODE": "CBS",
    "VENUE_TYPE": "Training",
    "SPORT_1": "Basketball",
    "SPORT_2": "",
    "SPORT_3": "",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "Cairns Basketball Stadium"
  },
  {
    "X": 146.80113501639778,
    "Y": -19.307927635517245,
    "OBJECTID": 28,
    "GlobalID": "451e9d5a-23d7-4968-995e-3854473004a7",
    "VENUE_NAME": "Townsville RSL Stadium",
    "VENUE_CODE": "TVS",
    "VENUE_TYPE": "Training",
    "SPORT_1": "",
    "SPORT_2": "",
    "SPORT_3": "",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": ""
  },
  {
    "X": 153.53608083817025,
    "Y": -28.166599122864717,
    "OBJECTID": 29,
    "GlobalID": "e1a56b1e-93b3-41fc-b455-f00a80834e61",
    "VENUE_NAME": "Coolangatta",
    "VENUE_CODE": "COL",
    "VENUE_TYPE": "Competition",
    "SPORT_1": "Beach Volley Ball",
    "SPORT_2": "",
    "SPORT_3": "",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "Beach Volleyball"
  },
  {
    "X": 153.38614888662192,
    "Y": -27.95721636787143,
    "OBJECTID": 30,
    "GlobalID": "544b15f3-96f9-4bca-8774-fd302666b29f",
    "VENUE_NAME": "Parkwood Sharks Oval",
    "VENUE_CODE": "PSO",
    "VENUE_TYPE": "Training",
    "SPORT_1": "Rugby Sevens",
    "SPORT_2": "",
    "SPORT_3": "",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "Parkwopd Sharks Oval - Community Rugby venue offering sporting facilities that will be available for athlete training pre and during Games period"
  },
  {
    "X": 153.40853089881261,
    "Y": -27.968804286502376,
    "OBJECTID": 31,
    "GlobalID": "2fd39623-0cec-4c42-8ab3-36d47e012e67",
    "VENUE_NAME": "St Hilda's School",
    "VENUE_CODE": "SHC",
    "VENUE_TYPE": "Training",
    "SPORT_1": "Gymnastics Rhythmic",
    "SPORT_2": "Wrestling",
    "SPORT_3": "",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "St Hilda's school - The private school facility is regularly used for pre-sporting event training and training camps. Rythmic Gymnastics: 11-13th April, Wrestling: 25March - 14th April 2018"
  },
  {
    "X": 153.4140365123906,
    "Y": -27.98578627358049,
    "OBJECTID": 32,
    "GlobalID": "e85f6a5f-a52e-4a60-affc-602ab79a925c",
    "VENUE_NAME": "The Southport School",
    "VENUE_CODE": "TSS",
    "VENUE_TYPE": "Training",
    "SPORT_1": "Rugby Sevens",
    "SPORT_2": "Swimming",
    "SPORT_3": "Basketball",
    "SPORT_4": "",
    "SPORT_5": "",
    "DESCRIPTION": "The Southport School - The private school facility is regularly used for pre-sport event training and training camps. Rugby 7's: 13th-15th April, Basketball: 10-15th April, Swimming: 5th-10th April 2018"
  }
];


// WEBPACK FOOTER //
// ./src/data/venues.js